import { signIn } from "../../actions/admin";
import { captchaMews } from "../../actions/user";
import { SKeyboard } from "../../components/keyboard";
import { admin_routes as routes } from "../../constants/routes";
import { FormUtils } from "../../utils/_FormUtils";
import { PermissionsUtils, _p } from "../../utils/_PermissionsUtils";

let key_mews = "";
const captcha_type = $("#form_type").val();

async function loadCaptcha() {
    const res = await captchaMews()
    $("#captcha_img").attr("src", res.img);
    key_mews = res.key;

    $("#captcha_div").show();
    $("#btn_submit").removeAttr("disabled");

}

if (captcha_type === "google") {
    FormUtils.addGoogleCaptcha();
} else if (captcha_type === "mews") {
    loadCaptcha();
} else {
    $("#btn_submit").removeAttr("disabled");
}

/**
 *handles the redirect
 *
 */
function redirect() {
    PermissionsUtils.loadPermissions().then(() => {
        if (_p("dashboard")) {
            window.location.href = routes.home;
        } else if (_p("getPostsForAdmin")) {
            window.location.href = "/blog/posts";
        } else {
            window.location.href = "/profile";
        }
    });
}

new SKeyboard().add();

$(() => {
    $("#username").trigger("focus");

    $("#captcha_retry").on("click", () => {
        $("#btn_submit").attr("disabled", "disabled");
        loadCaptcha();
    });

    $("form").on("submit", (event) => {
        event.preventDefault();
        const form = $(event.target);
        form.addClass("loading");
        if (captcha_type === "google") {
            if (FormUtils.validateForm(event.target)) {
                FormUtils.renewGoogleCaptcha().then(() => {
                    const username = form.find("input#username").val();
                    const password = form.find("input#password").val();
                    const captcha_val = form
                        .find("#g-recaptcha-response")
                        .val();
                    signIn(username, password, captcha_val)
                        .then(() => {
                            redirect();
                        })
                        .finally(() => {
                            form.removeClass("loading").removeClass(
                                "was-validated"
                            );
                        });
                });
            } else {
                setTimeout(() => {
                    form.removeClass("loading");
                }, 300);
            }
        } else if (captcha_type === "mews") {
            const username = form.find("input#username").val();
            const password = form.find("input#password").val();
            const captcha_val = form
                .find("input#captcha")
                .val();
            signIn(username, password, captcha_val, key_mews)
                .then(() => {
                    redirect();
                })
                .catch(() => {
                    form.removeClass("loading").removeClass("was-validated");
                    $("#btn_submit").attr("disabled", "disabled");
                    loadCaptcha();
                });
        } else {
            if (FormUtils.validateForm(event.target)) {
                const username = form.find("input#username").val();
                const password = form.find("input#password").val();
                signIn(username, password)
                    .then(() => {
                        redirect();
                    })
                    .catch(() => {
                        form.removeClass("loading").removeClass(
                            "was-validated"
                        );
                    });
            } else {
                setTimeout(() => {
                    form.removeClass("loading");
                }, 300);
            }
        }
    });
});
